// extracted by css-extract-rspack-plugin
export default {"image":"Block-module__image___bgf43","image-box":"Block-module__image-box___rLXc7","imageBox":"Block-module__image-box___rLXc7","instructions":"Block-module__instructions___xEoFv"};